"use client";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

// Note: PostHog is initialized in instrumentation-client.ts for Next.js 16.1.6+
// Do NOT call posthog.init() here - it would create duplicate initialization

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
